import { Chip, Divider, Grid, Skeleton, Typography } from "@mui/material"
import { Stack } from "@mui/system"

import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import { fetchDetailedPriceLists, PriceListQuery } from "../priceListApi"

type DetailedPriceListProps = Readonly<{
    id: number
}>

export function DetailedPriceList({ id }: DetailedPriceListProps) {
    const detailedPriceList = useApiQuery(fetchDetailedPriceLists, {
        queryName: PriceListQuery.DETAILS,
        dependencies: {
            id: id ?? 0,
        },
        enabled: Boolean(id),
    })

    if (detailedPriceList.data) {
        const shops = (detailedPriceList.data.priceList.shops ?? []).filter((shop) => Boolean(shop.name))
        const customers = (detailedPriceList.data.priceList.customers ?? []).filter((company) => Boolean(company.name))

        return (
            <>
                <Grid container direction={"column"} gap={"1rem"} marginX={"3rem"} marginY={"2rem"} width="auto">
                    <LocalizedStrict id="price-list-currency">
                        <Typography fontWeight="bold" variant="body2">
                            Currency:
                        </Typography>
                    </LocalizedStrict>
                    <Typography variant="body2">
                        {detailedPriceList.data.priceList.priceSetup?.currencyCode ?? "-"}
                    </Typography>
                    <Divider />

                    <LocalizedStrict id="price-list-vat-code">
                        <Typography fontWeight="bold" variant="body2">
                            VAT code:
                        </Typography>
                    </LocalizedStrict>
                    <Typography variant="body2">
                        {detailedPriceList.data.priceList.priceSetup?.vatCodeId ?? "-"}
                    </Typography>
                    <Divider />

                    <LocalizedStrict id="price-list-shops">
                        <Typography fontWeight="bold" variant="body2">
                            Connected Shops:
                        </Typography>
                    </LocalizedStrict>
                    {shops.length > 0 ? (
                        <Stack direction="row" spacing={1}>
                            {shops.map((shop) => (
                                <Chip key={shop.id} label={shop.name} />
                            ))}
                        </Stack>
                    ) : (
                        <Typography variant="body2">-</Typography>
                    )}
                    <Divider />

                    <LocalizedStrict id="price-list-company">
                        <Typography fontWeight="bold" variant="body2">
                            Connected Company:
                        </Typography>
                    </LocalizedStrict>
                    {customers.length > 0 ? (
                        <Stack direction="row" spacing={1}>
                            {customers.map((company) => (
                                <Chip key={company.id} label={company.name} />
                            ))}
                        </Stack>
                    ) : (
                        <Typography variant="body2">-</Typography>
                    )}
                    <Divider />
                </Grid>

                {/* <Table sx={{ marginY: "2rem", background: "#f8fafc", }}>
                    <TableHead>
                        <TableRow>
                            <TableCell> {l10n.getString("price-list-vat-code")}</TableCell>
                            <TableCell>{l10n.getString("price-list-currency")}</TableCell>
                            <TableCell>{l10n.getString("price-list-shops")}</TableCell>
                            <TableCell>{l10n.getString("price-list-company")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{detailedPriceList.data.priceList.priceSetup.vatCodeId}</TableCell>
                            <TableCell>{detailedPriceList.data.priceList.priceSetup.currencyCode}</TableCell>
                            <TableCell>
                                <Stack direction="row" spacing={1}>
                                    {(detailedPriceList.data.priceList.shops ?? []).map((shop) => {
                                        return (
                                            <Chip label={shop.name} />
                                        )
                                    })}
                                </Stack>
                            </TableCell>

                            <TableCell>
                                <Stack direction="row" spacing={1}>
                                    {(detailedPriceList.data.priceList.customers ?? []).map((company) => {
                                        return (
                                            <Chip label={company.name} />
                                        )
                                    })}
                                </Stack>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table> */}
            </>
        )
    } else if (detailedPriceList.isError) {
        // show error
    }

    // show loading state
    return <Skeleton variant="rectangular" width={"100%"} height={300} />
}
